import React from "react";

import { makeStyles } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import PropTypes from "prop-types";
import { useHistory, useLocation } from "react-router-dom";

const useStyles = makeStyles(({ breakpoints, palette: { grey } }) => ({
  root: {
    position: "relative",
  },
  top: {
    display: "flex",
    alignItems: "center",
    height: 56,
    padding: "0 4px",
    [breakpoints.up("lg")]: {
      padding: "0 8px",
    },
  },
  back: {
    position: "relative",
  },
  titles: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    minWidth: 1,
    padding: "0 8px",
  },
  title: {
    display: "block",
    position: "relative",
    margin: 0,
    padding: 0,
    fontWeight: 500,
    fontSize: "1.2rem",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
  subtitle: {
    display: "block",
    position: "relative",
    fontSize: "0.86rem",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    color: grey[500],
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    flexGrow: 1,
  },
  content: {
    width: "100%",
    position: "relative",
  },
}));

function RbHeader(props) {
  const { title, subtitle, actions, onBack, children } = props;

  const { pathname } = useLocation();

  const history = useHistory();

  const classes = useStyles();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      const pathParts = pathname.split("/");
      if (pathParts.length > 1) {
        pathParts.pop();
        history.push(pathParts.join("/"));
      }
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.top}>
        <div className={classes.back}>
          <IconButton aria-label="back" onClick={handleBack}>
            <ArrowBackIcon size="medium" />
          </IconButton>
        </div>
        <div className={classes.titles}>
          <h1 className={classes.title}>{title}</h1>
          <div className={classes.subtitle}>{subtitle}</div>
        </div>
        <div className={classes.actions}>{actions}</div>
      </div>
      {children && <div className={classes.content}>{children}</div>}
    </div>
  );
}

RbHeader.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  actions: PropTypes.node,
  children: PropTypes.node,
  onBack: PropTypes.func,
};

RbHeader.defaultProps = {
  title: null,
  subtitle: null,
  actions: null,
  children: null,
  onBack: undefined,
};

export default React.memo(RbHeader);
